import {connect} from '../../app/connect';
import IssueDetailsModalView from './IssueDetailsModalView';
import {closeIssueDetailsModalViewEventTriggerAction} from '../../app/actions';
import {getCurrentPreviewIssueId, hasPermissionsViolation} from '../../app/selectors';

const mapStateToProps = state => ({
  issueId: getCurrentPreviewIssueId(state),
  hasViolation: hasPermissionsViolation(state)
});

const mapDispatchToProps = {
  closeIssueDetailsModalViewEventTriggerAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueDetailsModalView);
